import Vue from 'vue'
import Vuex from 'vuex'
import audience from './models/audience'
import performer from './models/performer'
import curationSiteArticle from './models/curationSiteArticle'
import sku from './models/sku'
import actioncable from './models/actioncable'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    audience,
    actioncable,
    performer,
    curationSiteArticle,
    sku,
  },
  strict: debug
})
